import { useNotifications as _useNotifications } from '@hwm/ui-lib';
import { ErrorCodesDictionaryFn } from '@shared/dictionaries';

export const useNotifications = () => {
  const notifications = _useNotifications(ErrorCodesDictionaryFn());

  return {
    handleSuccess: notifications.handleSuccess,
    handleError: notifications.handleError,
    handleWarning: notifications.handleWarning,
  };
};
